import React from 'react';
import { withRouter } from 'react-router-dom';

import Carousel from '../../components/Carousel';
import { NextPageOnlyArrow } from '../../components/nextPage/NextPage';

const Home = () => {
  return (
    <section className={'cdo-section'}>
      <Carousel />
      <NextPageOnlyArrow />
    </section>
  );
};

export default withRouter(Home);
